import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useAndroidSafePadding = () => {
  const location = useLocation();
  const isAndroid = /Android/.test(navigator.userAgent);

  const rutasBodyPadding = [
    "/", "/home", "/registro", "/departamento", "/categorias", "/comercios", "/mapa",
    "/destino", "/destinos", "/ruleta", "/referidos", "/retiros", "/cuentas",
    "/ofertas", "/trending", "/intereses", "/terminos", "/politicas", "/seguidos",
    "/pagos", "/favoritos", "/chats",
  ];

  const rutaComercio = "/comercio";
  const rutaCentro = "/evento";
  const rutaEvento = "/evento";

  useEffect(() => {
    const path = location.pathname;

    const aplicarBodyPadding = isAndroid && rutasBodyPadding.some(ruta =>
      path === ruta || path.startsWith(`${ruta}/`)
    );
        
    const aplicarSoloPromoHeader = isAndroid && (path === rutaComercio || path.startsWith(`${rutaComercio}/`) || path === rutaCentro || path.startsWith(`${rutaCentro}/`) );

    const body = document.body;
    body.style.paddingTop = aplicarBodyPadding ? "34px" : "";

    const aplicarPaddingPromo = () => {
      const promoHeader = document.querySelector(".promo-header");
      if (promoHeader) {
        promoHeader.style.paddingTop = aplicarSoloPromoHeader ? "37px" : "";
      }
    };
    aplicarPaddingPromo();
    const observer = new MutationObserver(() => aplicarPaddingPromo());
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [location.pathname]);
};

export default useAndroidSafePadding;